<template lang="pug">
div
  v-dialog(v-model="showDialog" max-width="600" persistent scrollable content-class="round-3xl")
    v-card
      v-card-title.px-8
        v-row(no-gutters align="center")
          v-col(cols="10" offset="1")
            div.text-xl.font-bold.neutral700--text.text-center Recurring appointments
          v-col(cols="1" align="right")
            v-btn.ml-n3(text icon @click="closeDialog")
              v-icon(color="neutral700" :size="24") mdi-close
      
      v-divider

      v-card-text.pa-8.neutral700--text
        .d-flex.justify-space-between.align-center.mb-4
          .text-md.font-semibold Recurring appointment list
          .text-xs.font-semibold.underline.clickable(@click="onEditRecurringAppointment") Edit recurring appointment
        //- Loading state
        template(v-if="isFetching")
          v-skeleton-loader.my-3(type="text@3")
        template(v-else)
          //- Listing
          template(v-if="recurring.length > 0")
            div(v-for="(recur, recurIdx) in recurring" :key="recur.id")
              recurring-appointment-list-item(:parentRecur="recur" @view="onClickView(recur)" @setDate="onEditRecurringAppointment")

              v-divider.my-2(v-if="recurIdx !== recurring.length - 1")
            y-pagination.py-4(v-model="page" :pageSize="pageSize" :count="count" :loading="isFetching")
      
      v-divider

      v-card-actions.px-6.py-4
        v-btn.button-md.underline.px-0(text @click="closeDialog") {{ $t('close') }}
        v-spacer
        v-btn.button-md(color="primary" depressed @click="closeDialog") {{ $t('done') }}

  .dialogs
    edit-recurring-appointment-dialog(v-if="openEditRecurringAppointmentDialog" :open.sync="openEditRecurringAppointmentDialog" :recurFor="recurFor" @refetch="fetchSeries")

</template>

<script>
import { DateTime } from 'luxon'
import { mapGetters, mapActions } from 'vuex'
import RecurringAppointmentListItem from '@/components/clinic/appointment/calendar/RecurringAppointmentListItem.vue'
import EditRecurringAppointmentDialog from '@/components/clinic/appointment/advance/EditRecurringAppointmentDialog.vue'

export default {
  components: {
    RecurringAppointmentListItem, EditRecurringAppointmentDialog
  },
  props: {
    open: {
      type: Boolean
    },
    recurFor: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isFetching: true,
      recurring: [],
      page: 1,
      pageSize: 25, // current limit for recur items is 25
      count: 0,
      openEditRecurringAppointmentDialog: false
    }
  },
  mounted () {
    this.fetchSeries()
  },
  watch: {
    page () {
      this.fetchSeries()
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      isHq: 'hq/getIsHq',
      hqSelectedCompany: 'hq/getSelectedCompany'
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    },
    params () {
      return {
        page: this.page,
        page_size: this.pageSize,
        recur_for: this.recurFor
      }
    },
    companySlug () {
      return this.isHq ? this.hqSelectedCompany.slug : this.company.slug
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    closeDialog () {
      this.showDialog = false
    },
    async fetchSeries () {
      try {
        this.isFetching = true
        const { data } = await this.$axios.get(`/clinics/${this.companySlug}/appointments`, { params: this.params })
        if (data.count > 0) {
          this.recurring = data.results
          this.count = data.count
        }
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        this.showDialog = false
      } finally {
        this.isFetching = false
      }
    },
    onClickView (item) {
      // Formatting
      const selected = {...item}
      selected.datetime = { from: DateTime.fromISO(item.start) }
      // Emit
      this.$emit('view', selected)
      this.showDialog = false
    },
    onEditRecurringAppointment () {
      this.openEditRecurringAppointmentDialog = true
    }
  },
}
</script>

<style scoped>
</style>